module.exports = __webpack_public_path__ + "img/info_bg.b348a372.png";